import { FC } from "react";
import { Card, Paragraph } from "capitalrx-components-2.0";

import { FAQDataProps } from "../FAQSection.props";
import styles from "../FAQSection.module.scss";

const FAQCardContent: FC<FAQDataProps> = ({ content, Image, id }: FAQDataProps) => {
  return (
    <Card className={styles.FAQContent} testId={`faq-content-${id}`}>
      <Paragraph className={styles.FAQContentText} id={id}>
        {content}
      </Paragraph>
      {Image && <div className={styles.FAQImages}>{Image}</div>}
    </Card>
  );
};

export default FAQCardContent;
